import React , { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

class Dialogdetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      totalSales: 0,
      dialogDetail: this.props.datanya,
      mantap: props.mantap
    };
  }

  componentDidMount (){
    console.log(this.state.dialogDetail, this.state.mantap);
  }

  render(){
    return (
      <div>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
              <TableRow key={1}>
                <TableCell component="th" scope="row">
                  Kode
                </TableCell>
                <TableCell align="">A</TableCell>
              </TableRow>
              <TableRow key={2}>
                <TableCell component="th" scope="row">
                  Nama
                </TableCell>
                <TableCell align="">REFERENSI SPASIAL</TableCell>
              </TableRow>
              <TableRow key={3}>
                <TableCell component="th" scope="row">
                  Definisi
                </TableCell>
                <TableCell align="">Dataset tentang Referensi koordinat yang digunakan dalam pendefinisian dan penentuan posisi suatu entitas geospasial mencakup posisi horisontal, vertikal, maupun nilai gaya berat berikut perubahannya sebagai fungsi waktu</TableCell>
              </TableRow>
              <TableRow key={4}>
                <TableCell component="th" scope="row">
                  Unsur Abstrak
                </TableCell>
                <TableCell align="">False</TableCell>
              </TableRow>
              <TableRow key={5}>
                <TableCell component="th" scope="row">
                  Alias
                </TableCell>
                <TableCell align="">KATEGORI REFERENSI SPASIAL</TableCell>
              </TableRow>
              <TableRow key={6}>
                <TableCell component="th" scope="row">
                  Tanggal
                </TableCell>
                <TableCell align="">-</TableCell>
              </TableRow>
              <TableRow key={7}>
                <TableCell component="th" scope="row">
                  Tipe Tanggal
                </TableCell>
                <TableCell align="">Publikasi</TableCell>
              </TableRow>
              <TableRow key={8}>
                <TableCell component="th" scope="row">
                  Edisi
                </TableCell>
                <TableCell align="">-</TableCell>
              </TableRow>
              <TableRow key={9}>
                <TableCell component="th" scope="row">
                  Role
                </TableCell>
                <TableCell align="">Walidata</TableCell>
              </TableRow>
              <TableRow key={10}>
                <TableCell component="th" scope="row">
                  Nama Katalog
                </TableCell>
                <TableCell align="">Katalog Unsur Geografi</TableCell>
              </TableRow>
              <TableRow key={10}>
                <TableCell component="th" scope="row">
                  Nama Organisasi
                </TableCell>
                <TableCell align="">-</TableCell>
              </TableRow>

          </TableBody>
        </Table>
    </TableContainer>
    <br/>
    <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Kode Sub Kategori</TableCell>
              <TableCell align="">Nama Sub Kategori</TableCell>
              <TableCell align="">Definisi</TableCell>
              <TableCell align="">Unsur Abstrak</TableCell>
              <TableCell align="">Alias</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              <TableRow key={1}>
                <TableCell component="th" scope="row">
                  AA
                </TableCell>
                <TableCell align="right">ARING KONTROL GEODESI</TableCell>
                <TableCell align="right">Sebaran titik kontrol geodesi yang terintegrasi dalam satu kerangka referensi.</TableCell>
                <TableCell align="right">-</TableCell>
                <TableCell align="right">SUB KATEGORI JARING KONTROL GEODESI</TableCell>
              </TableRow>
              <TableRow key={2}>
                <TableCell component="th" scope="row">
                  AA
                </TableCell>
                <TableCell align="right">ARING KONTROL GEODESI</TableCell>
                <TableCell align="right">Sebaran titik kontrol geodesi yang terintegrasi dalam satu kerangka referensi.</TableCell>
                <TableCell align="right">-</TableCell>
                <TableCell align="right">SUB KATEGORI JARING KONTROL GEODESI</TableCell>
              </TableRow>
          </TableBody>
        </Table>
    </TableContainer>
    </div>
    )
  }
}

export default Dialogdetail
